import baseApi from "@/lib/redux/api/baseApi";

export const locationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Add Location
    addLocation: builder.mutation({
      query: (locationData) => ({
        url: "/location",
        method: "POST",
        body: locationData,
      }),
    }),
    // Edit Location
    editLocation: builder.mutation({
      query: ({ guid, locationData }) => ({
        url: `/location/edit/${guid}`,
        method: "POST",
        body: locationData,
      }),
    }),
    // Delete Location
    deleteLocation: builder.mutation({
      query: (guid) => ({
        url: `/location/delete/${guid}`,
        method: "DELETE",
      }),
    }),
    // Delete Location Room
    deleteLocationRoom: builder.mutation({
      query: (id) => ({
        url: `/location/delete/room/${id}`,
        method: "DELETE",
      }),
    }),
    // View Locations by User ID
    viewLocationsByUserId: builder.query({
      query: (userId) => ({
        url: `/location/view/${userId}`,
        method: "GET",
      }),
    }),
    // View Rooms by Location GUID
    viewRoomsByGuid: builder.query({
      query: (guid) => ({
        url: `/location/view/room/${guid}`,
        method: "GET",
      }),
    }),
    // Delete Room by Room ID
    deleteRoomById: builder.mutation({
      query: (id) => ({
        url: `/location/delete/room/${id}`,
        method: "DELETE",
      }),
    }),
    // Get Location by ID
    getLocationById: builder.query({
      query: (id) => ({
        url: `/location/get/${id}`,
        method: "GET",
      }),
    }),
    // view all the sessions for a particular location
    viewSessionsByLocationGuid: builder.query({
      query: (guid) => ({
        url: `/session/view/all_session/${guid}`,
        method: "GET",
      }),
    }),
    // delete media for a location
    deleteMediaByIdForLocation: builder.mutation({
      query: (id) => ({
        url: `/location/delete/media/${id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: true,
});

// Export hooks
export const {
  useAddLocationMutation,
  useEditLocationMutation,
  useDeleteLocationMutation,
  useDeleteLocationRoomMutation,
  useViewLocationsByUserIdQuery,
  useViewRoomsByGuidQuery,
  useDeleteRoomByIdMutation,
  useGetLocationByIdQuery,
  useViewSessionsByLocationGuidQuery,
  useDeleteMediaByIdForLocationMutation,
} = locationApi;
